import { Directive, inject, input, InputSignal, OnChanges } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { InputItemModel } from '@libs/form/models';
import { ValidatorService } from '../../services';

@Directive({
  selector: 'input[uiFormInputValidators],textarea[uiFormInputValidators],select[uiFormInputValidators],mat-list[uiFormInputValidators]',
})
export class InputValidatorsDirective implements OnChanges {
  private readonly validatorService: ValidatorService = inject(ValidatorService);

  public control: InputSignal<AbstractControl> = input.required();
  public data: InputSignal<InputItemModel> = input.required();

  public ngOnChanges(): void {
    this.control().clearValidators();
    this.validatorService.attachControlValidators(this.control(), this.data());
  }
}
